module.exports = __webpack_public_path__ + "img/628.5f720304.jpg";